import React, { CSSProperties, useCallback, useMemo, useState } from "react";
import { Select } from "antd";
import AbstractDeclarantStore from "../../stores/AbstractDeclarantStore";
import { Option } from "../common/forms/Interfaces";
import ActionButton from "./groupButton";
import Authorize from "../Authorize";
import { EDIT_DECLARANT } from "../../constants/authorize";

type AssignClientContainerProps = {
  store: AbstractDeclarantStore;
  clients: Option[];
};

const textStyles: CSSProperties = {
  textAlign: "center",
  lineHeight: "12px",
  fontSize: "12px",
  padding: 0,
  margin: 0,
};

const AssignClientContainer = ({
  store,
  clients,
}: AssignClientContainerProps) => {
  const [clientId, setClientId] = useState<number | undefined>(undefined);

  const isDisabled = useMemo(
    (): boolean => store.selectedRows.length === 0 || clientId === undefined,
    [store.selectedRows, clientId]
  );

  const handleAssign = useCallback(async (): Promise<void> => {
    if (clientId === undefined) {
      return;
    }

    await store.assignClientToSelected(clientId);
  }, [store, clientId]);

  const AssignButton = ({ disabled = false }: { disabled?: boolean }) => (
    <ActionButton
      disabled={disabled || isDisabled}
      onClick={handleAssign}
      text="Assign"
      loading={store.isAssigningClient}
    />
  );

  return (
    <div
      style={{
        padding: "4px 16px 4px 10px",
        background: "white",
        position: "relative",
        minWidth: "220px",
      }}
      className="border"
    >
      <div
        style={{
          alignItems: "center",
        }}
        className="row-container"
      >
        <p
          style={{
            ...textStyles,
            fontWeight: "bold",
          }}
        >
          Assign Client:
        </p>
        <Select
          value={clientId}
          onChange={setClientId}
          placeholder="Select client"
          size="small"
          showSearch
          allowClear
          filterOption={(input, option) => {
            if (!option) {
              return false;
            }

            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          style={{ minWidth: "160px" }}
        >
          {clients.map((client) => (
            <Select.Option key={client.value} value={client.value}>
              {client.title}
            </Select.Option>
          ))}
        </Select>
        <Authorize
          deniedComponent={<AssignButton disabled />}
          permission={EDIT_DECLARANT}
        >
          <AssignButton />
        </Authorize>
      </div>
    </div>
  );
};

export default AssignClientContainer;
